/**
 * @generated SignedSource<<cf4b68925217e14efe2db4b4addc9780>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ProfileMutationsDeletePoolMutation$variables = {
  id: string;
};
export type ProfileMutationsDeletePoolMutation$data = {
  readonly deleteCrewPool: {
    readonly id: string;
  };
};
export type ProfileMutationsDeletePoolMutation = {
  response: ProfileMutationsDeletePoolMutation$data;
  variables: ProfileMutationsDeletePoolMutation$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'id',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'id',
            variableName: 'id',
          },
        ],
        concreteType: 'CrewPool',
        kind: 'LinkedField',
        name: 'deleteCrewPool',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'id',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'ProfileMutationsDeletePoolMutation',
      selections: v1 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'ProfileMutationsDeletePoolMutation',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '98f7871da22ff86cd2659e94b3d59597',
      id: null,
      metadata: {},
      name: 'ProfileMutationsDeletePoolMutation',
      operationKind: 'mutation',
      text: 'mutation ProfileMutationsDeletePoolMutation(\n  $id: ID!\n) {\n  deleteCrewPool(id: $id) {\n    id\n  }\n}\n',
    },
  };
})();

(node as any).hash = '0b9e018024bb9d79da20b0a44a7d4bd0';

export default node;
